import { Breadcrumb, Button, Card, Col, Row, Space, Spin } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Title from 'antd/es/typography/Title';
import React, { useEffect, useMemo, useRef, useState} from 'react';
import Plot from 'react-plotly.js';
import { AreaChartOutlined, HomeOutlined } from '@ant-design/icons';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context';

const VSPSurveyInversionImaging = () => {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	// const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	// const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	// const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	// const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const { state } = useLocation();
	const navigate = useNavigate();
	const {wellFieldinfo, getWellFieldsInfo, surveySeriesinfo, getSurveySeriesInfo} = useAuth();
	const [playAnimation, setPlayAnimation] = useState(false);
	const [restAnimation, setRestAnimation] = useState(true);

	const originalZ = state?.data?.cubedata?.z || [];
	const [zdata, setZData] = useState(originalZ);
	const [tick, setTick] = useState(0);

	const timeoutRef = useRef(null);

	const playLoop = (currentTick) => {
		if (!playAnimation) return;
		
		if(tick==0){
			setZData(originalZ);
		}

		if (currentTick >= 10) {
			setZData([]);
			setPlayAnimation(false);
			setTick(0);
			return;
		}

		const newValue = parseFloat(((10 - (currentTick + 1)) / 10).toFixed(1));
		const updatedZ = [
			0, 0, 0, 0,
			newValue,
			newValue,
			newValue,
			newValue,
		];

		setZData(updatedZ);
		setTick(currentTick + 1);

		timeoutRef.current = setTimeout(() => {
			playLoop(currentTick + 1);
		}, 1000);
	};

	// Trigger play loop when playAnimation becomes true
	useEffect(() => {
		if (playAnimation && tick < 10) {
			playLoop(tick);
		}

		return () => clearTimeout(timeoutRef.current); // Cleanup
	}, [playAnimation]);

	// Reset everything when reset is triggered
	useEffect(() => {
		if (restAnimation) {
			clearTimeout(timeoutRef.current);
		}
	}, [restAnimation]);
	
	useEffect(() => {
		getWellFieldsInfo(authtoken);
		getSurveySeriesInfo(authtoken, null);
	},[authtoken]);
	
	const wellFields = [];
	wellFieldinfo && wellFieldinfo.map((item) => {
		wellFields.push({
			value : item.id,
			label : item.name.toUpperCase(),
			distanceFrom: item.distanceFrom,
			distanceTo: item.distanceTo,
			depthFrom: item.depthFrom,
			depthTo: item.depthTo

		});

	});

	const suveySeriesData = [];
	surveySeriesinfo && surveySeriesinfo.map((item) => {
		suveySeriesData.push({
			value : item.id,
			label : item.name.toUpperCase()
		});
		
	});

	const data = [];	


	const layout =useMemo(() => ({
		title: {
			text: langdata?.VSP3dImaging || 'VSP 3d Imaging',
			font: { size: 20, weight: 'bold' },
		},
		
		margin: { t: 40, r: 40, l: 60, b: 60 },

		scene: {
			xaxis: {
				title: langdata && langdata.Distancem ? langdata.Distancem : 'Distance (m)',
				color: 'black',          // Axis title & tick label color
				gridcolor: 'lightgray',  // Grid line color
				zerolinecolor: 'gray',   // Zero line color
				showbackground: true,
				backgroundcolor: '#ffffff', // X axis plane background
				range: [10,0]
			},
			yaxis: {
				title: langdata && langdata.Offset ? langdata.Offset : 'Offset',
				color: 'black',
				gridcolor: 'lightgray',
				zerolinecolor: 'gray',
				showbackground: true,
				backgroundcolor: '#ffffff',			},
			zaxis: {
				title: langdata && langdata.Depthm ? langdata.Depthm : 'Depth (m)',
				color: 'black',
				gridcolor: 'lightgray',
				zerolinecolor: 'gray',
				showbackground: true,
				backgroundcolor: '#ffffff',
				// autorange: 'reversed',
				range: [0,1]
			},
			camera:{
				eye: { x: 2.2, y: 2.4, z: 1 },
				center: { x: 0, y: 0, z: -.3 },
				up: { x: 0, y: 0, z: 2 },
			},
			aspectratio: { x: 3, y: 1.5, z: 1 },
		},
	}), [langdata]);


	const cubedata = {

		type: 'mesh3d',

		x: state && state.data && state.data?.cubedata?.x ? state.data.cubedata.x : [],

		y: state && state.data && state.data?.cubedata?.y ? state.data.cubedata.y : [],

		z: restAnimation == true ? originalZ : zdata,

		i: state && state.data && state.data?.cubedata?.i ? state.data.cubedata.i : [],

		j: state && state.data && state.data?.cubedata?.j ? state.data.cubedata.j : [],

		k: state && state.data && state.data?.cubedata?.k ? state.data.cubedata.k : [],

		intensity: state && state.data && state.data?.cubedata?.intensity ? state.data.cubedata.intensity : [],

		colorscale: 'RdBu',
		colorbar: {thickness: 10,
			// thicknessmode: 'pixels',
			// lenmode: 'fraction',
			outlinewidth: 0},
		hovertemplate: ` ${langdata?.Distancem ?? 'Distance (m)'} : %{x} <br> ${langdata?.Offset ?? 'Offset'} : %{y} <br> ${langdata?.Depth ?? 'Depth'} : %{z}<extra></extra>`,

	};

	data.push(cubedata);

	const meshdata={
		opacity:0.8,
		colorscale:'RdBu',
		// intensity: [0, 0.1, 0.11, 0.15, 0.2, 0.25, 0.3, 0.35, 0.8],
		// color:'rgb(300,100,200)',
		colorbar: {thickness: 10,
			// thicknessmode: 'pixels',
			// lenmode: 'fraction',
			outlinewidth: 0,
		},
		type: 'mesh3d',
		x: state && state.data && state.data?.meshdata?.x ? state.data.meshdata.x : [],

		y: state && state.data && state.data?.meshdata?.y ? state.data.meshdata.y : [],

		z: state && state.data && state.data?.meshdata?.z ? state.data.meshdata.z : [],
		
		hovertemplate: ` ${langdata?.Distancem ?? 'Distance (m)'} : %{x} <br> ${langdata?.Offset ?? 'Offset'} : %{y} <br> ${langdata?.Depth ?? 'Depth'} : %{z}<extra></extra>`,
	};	

	data.push(meshdata);

	const handlePlayanimation = (value) =>{
		setPlayAnimation(value);
		setRestAnimation(false);
	};

	const handleResetanimation = (value) =>{
		setPlayAnimation(false);
		setRestAnimation(value);
		setTick(0);
		setZData(originalZ);

	};
	

	return (

		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
		
				<Col span={8}>
					<Row>
						<Space>
							<AreaChartOutlined style={{fontSize:'30px'}}/>
							{/* </Col> */}
						</Space>
						<Space>&nbsp;&nbsp;</Space>
							
						{/* <Col style={{marginLeft:'4px'}} span={19}> */}
						<Title level={4} style={{ paddingTop:'10px'}}> {langdata && langdata.VSP3dImaging ? langdata.VSP3dImaging:'VSP 3d Imaging'}</Title>
						
					</Row>
				</Col>
				<Col span={16}>
					&nbsp;
				</Col>
			</Row>
			<Row style={{
				margin: '10px',
				// marginTop : '5px',
				// paddingLeft: '10px',
				// paddingRight: '10px',
				// background: '#FFFFFF',
				alignItems:'center',
			}}  >
				<Col span={18}>
					<Breadcrumb
						items={[
							{
								href: '/dashboard',
								title: <HomeOutlined />,
							},
							{
								title: ( state && state?.path === 'well-visualization' ? <a onClick={()=>{navigate(-4);}}>{langdata && langdata.WellVisualization ? langdata.WellVisualization:'Well Visualization'}</a> :  <a onClick={()=>{navigate(-4);}}>{langdata && langdata.WellVisualization ? langdata.WellVisualization:'Well Visualization'}</a>)
							},
							{
								title: ( state && state?.path === 'vsp-survey' ? <a onClick={()=>{navigate(-3);}}>{langdata && langdata.VSPSurvey ? langdata.VSPSurvey:'VSP Survey'}</a> :  <a onClick={()=>{navigate(-3);}}>{langdata && langdata.VSPSurvey ? langdata.VSPSurvey:'VSP Survey'}</a>)
							},
							{
								title: ( state && state?.path === 'vsp-survey-details' ? <a onClick={()=>{navigate(-2);}}>{langdata && langdata.VSPSurveyDetails ? langdata.VSPSurveyDetails:'VSP Survey Details'}</a> :  <a onClick={()=>{navigate(-2);}}>{langdata && langdata.VSPSurveyDetails ? langdata.VSPSurveyDetails:'VSP Survey Details'}</a>)
							},
							{
								title: ( state && state?.path === 'vsp-survey-inversion' ? <a onClick={()=>{navigate(-1);}}>{langdata && langdata.Inversion ? langdata.Inversion:'Inversion'}</a> :  <a onClick={()=>{navigate(-1);}}>{langdata && langdata.Inversion ? langdata.Inversion:'Inversion'}</a>)
							},
							{
								title: `${langdata && langdata.VSP3dImaging ? langdata.VSP3dImaging:'VSP 3d Imaging'}`,
							},
						
						]}
						// style={{ marginBottom : '10px'}}
					/>
				</Col>
				<Col span={6} style={{ display : 'flex', justifyContent : 'flex-end'}}>
					{/* <Tooltip title={langdata && langdata.Graphlayout ? langdata.Graphlayout:'Graph layout'}>
						<Switch style={{backgroundColor: graphScroll == false ? '' : 'green'}} checkedChildren={langdata && langdata.Scroll ? langdata.Scroll:'Scroll'} unCheckedChildren={langdata && langdata.Fixed ? langdata.Fixed:'Fixed'} checked={graphScroll} onClick={handleSelectGraphScroll}/>
					</Tooltip> */}
				</Col>
			</Row>
			<Card style={{ minHeight: '500px', padding : '5px', marginLeft : '20px', marginRight : '20px'  }}>
				<Row style={{
					// margin: '10px',
					// marginBottom : '0px',
					// marginTop : '10px',
					// paddingLeft: '10px',
					// paddingRight: '10px',
					// backgroundColor: '#ffffff',
					alignItems:'center',
				}} >
					<Col span={24}>	
							
						<Col>
							{/* <Spin spinning={spin} tip={`${langdata && langdata.Loading ? langdata.Loading: 'Loading'}...`} > */}
							<Col span={24}>
								<Row>
									<Col span={24} style={{ marginBottom: '10px' }}>
										<Button
											type='primary'
											onClick={() => handlePlayanimation(!playAnimation)}
											style={{width:'70px'}}
										>
											{playAnimation ? langdata?.Pause || 'Pause' : langdata?.Play || 'Play'}
										</Button>
										<Space>&nbsp;&nbsp;&nbsp;</Space>
										<Button
											type='primary'
											style={{width:'70px'}}
											onClick={() => handleResetanimation(true)}
										>
											{langdata?.Reset || 'Reset'}
										</Button>
									</Col>
									{/* <Col span={2} style={{ marginBottom: '10px' }}>
									</Col> */}
								</Row>
							</Col>
							<>
								<Plot
									data={data}
									layout={layout}

									style={{ width: '100%', height: '800px' }}
									config={{
										responsive: true,
										displayModeBar: true,
										displaylogo : false,
										modeBarButtonsToRemove: [],
									}}

									// onUpdate={(figure) => {
									// 	if (
									// 		figure.layout &&
									// 		figure.layout.sliders &&
									// 		figure.layout.sliders[0] &&
									// 		typeof figure.layout.sliders[0].active === 'number'
									// 	) {
									// 		const newOffset = vspSurveyOffsetsarray[figure.layout.sliders[0].active];
									// 		if (newOffset !== fieldOffset) {
									// 			handleSetFieldOffset(newOffset); // <-- triggers dropdown logic too
									// 		}
									// 	}
									// }}
								/>
							</>
								
						</Col>
						{/* </Spin> */}
					</Col>
				</Row>
			</Card> 

	
			<Spin fullscreen spinning={false} />
		</Content>
		
	);
};

export default VSPSurveyInversionImaging;
